const root = {
    LOGIN: "login."
};

const EventBusEvents = {
    ERROR_CODE: root.LOGIN + "error_code",
    VERIFICATION_ERROR_CODE: root.LOGIN + "verify_error_code"
};

export default EventBusEvents;
